/**
 * mtc-backoffice-api
 * MTC Backoffice Composite Api
 *
 * OpenAPI spec version: 0.1.0-SNAPSHOT
 * Contact: developers@greysystems.eu
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs/Observable';

import { Agent } from '../model/agent';
import { AgentBasic } from '../model/agentBasic';
import { AgentSearchFilter } from '../model/agentSearchFilter';
import { AgentSearchResult } from '../model/agentSearchResult';
import { RestError } from '../model/restError';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class MtcAgentControllerService {

    protected basePath = 'https://mtc-ms-backoffice-api';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * bulkAgentBasicData
     * 
     * @param idAgentList idAgentList
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public bulkAgentBasicDataUsingGET(idAgentList: Array<number>, observe?: 'body', reportProgress?: boolean): Observable<Array<AgentBasic>>;
    public bulkAgentBasicDataUsingGET(idAgentList: Array<number>, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<AgentBasic>>>;
    public bulkAgentBasicDataUsingGET(idAgentList: Array<number>, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<AgentBasic>>>;
    public bulkAgentBasicDataUsingGET(idAgentList: Array<number>, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (idAgentList === null || idAgentList === undefined) {
            throw new Error('Required parameter idAgentList was null or undefined when calling bulkAgentBasicDataUsingGET.');
        }

        let headers = this.defaultHeaders;

        // authentication (Authorization) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.get<Array<AgentBasic>>(`${this.basePath}/agents/basic`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * getAgentBasicData
     * 
     * @param id id
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getAgentBasicDataUsingGET(id: number, observe?: 'body', reportProgress?: boolean): Observable<AgentBasic>;
    public getAgentBasicDataUsingGET(id: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<AgentBasic>>;
    public getAgentBasicDataUsingGET(id: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<AgentBasic>>;
    public getAgentBasicDataUsingGET(id: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling getAgentBasicDataUsingGET.');
        }

        let headers = this.defaultHeaders;

        // authentication (Authorization) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<AgentBasic>(`${this.basePath}/agents/${encodeURIComponent(String(id))}/basic`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * getAgentDetailData
     * 
     * @param id id
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getAgentDetailDataUsingGET(id: number, observe?: 'body', reportProgress?: boolean): Observable<Agent>;
    public getAgentDetailDataUsingGET(id: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Agent>>;
    public getAgentDetailDataUsingGET(id: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Agent>>;
    public getAgentDetailDataUsingGET(id: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling getAgentDetailDataUsingGET.');
        }

        let headers = this.defaultHeaders;

        // authentication (Authorization) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<Agent>(`${this.basePath}/agents/${encodeURIComponent(String(id))}/detail`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * searchAgentsUsingFilter
     * 
     * @param filter filter
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public searchAgentsUsingFilterUsingPOST(filter: AgentSearchFilter, observe?: 'body', reportProgress?: boolean): Observable<Array<AgentSearchResult>>;
    public searchAgentsUsingFilterUsingPOST(filter: AgentSearchFilter, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<AgentSearchResult>>>;
    public searchAgentsUsingFilterUsingPOST(filter: AgentSearchFilter, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<AgentSearchResult>>>;
    public searchAgentsUsingFilterUsingPOST(filter: AgentSearchFilter, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (filter === null || filter === undefined) {
            throw new Error('Required parameter filter was null or undefined when calling searchAgentsUsingFilterUsingPOST.');
        }

        let headers = this.defaultHeaders;

        // authentication (Authorization) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<Array<AgentSearchResult>>(`${this.basePath}/agents/search`,
            filter,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
